import React, { useCallback } from 'react';
import { CardStack } from '@/components/CardStack';
import type { CardData } from '@/components/CardStack';
import { toast } from 'sonner';

// Sample data for the cards
const sampleCards: CardData[] = [
  {
    id: '1',
    type: 'quote',
    content: {
      text: "The only way to do great work is to love what you do.",
      author: "Steve Jobs"
    }
  },
  {
    id: '2',
    type: 'question',
    content: {
      text: "What's one thing you've been putting off that you could complete today?",
      options: [
        "Start that project",
        "Call a friend",
        "Go for a walk"
      ]
    }
  },
  {
    id: '3',
    type: 'gif',
    content: {
      text: "Have a laugh! 😄",
      imageUrl: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExc2R2d3J0eXJjY2ZkNGN5Y2RqZ2FjZ2R4dHl1d3Q1eW9nZ3l6MSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3o7aTskHEUdgCQAXde/giphy.gif"
    }
  },
  {
    id: '4',
    type: 'fact',
    content: {
      text: "Honey never spoils. Archaeologists have found pots of honey in ancient Egyptian tombs that are over 3,000 years old and still perfectly good to eat!",
    }
  },
  {
    id: '5',
    type: 'challenge',
    content: {
      text: "Today's Challenge: Take a 10-minute walk outside and notice three beautiful things around you.",
    }
  }
];

const Home: React.FC = () => {
  const handleCardSwiped = useCallback((cardId: string, direction: 'left' | 'right') => {
    const action = direction === 'right' ? 'saved' : 'skipped';
    toast.success(`Card ${action}!`);
    console.log(`Card ${cardId} swiped ${direction}`);
  }, []);

  const handleAllCardsSwiped = useCallback(() => {
    toast.success("All cards completed for today!");
  }, []);

  return (
    <div className="min-h-screen bg-background p-4 flex flex-col overflow-x-hidden" style={{backgroundColor: '#0f172a'}}>
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-foreground">Wingman</h1>
        <p className="text-muted-foreground">Happy Wife, Happy Life</p>
      </header>
      
      <div className="flex-1 flex items-center justify-center">
        <CardStack 
          cards={sampleCards} 
          onCardSwiped={handleCardSwiped}
          onAllCardsSwiped={handleAllCardsSwiped}
        />
      </div>
    </div>
  );
};

export default Home;
